import { useContext } from 'react';
import { UserDataContext } from 'lane-shared/contexts';
import { hasPermissionOrSuperUser } from 'lane-shared/helpers';
import { PERMISSION_KEYS } from 'constants-permissions';

export type UseCoverageHoursPermissionsArgs = {
  channelId?: string;
};

export type UseCoverageHoursPermissionsResult = {
  canManage: boolean;
};

// Mirrors the coverage hours resolver gate: admin or the service request settings permission.
export function useCoverageHoursPermissions({
  channelId,
}: UseCoverageHoursPermissionsArgs): UseCoverageHoursPermissionsResult {
  const { user } = useContext(UserDataContext);

  const canManage = Boolean(
    user &&
      hasPermissionOrSuperUser(
        user,
        [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_SETTINGS],
        channelId ?? ''
      )
  );

  return { canManage };
}
